import moment from "moment";
import { Moment } from "moment";

const dateTimeFormatOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
    timeZone: "America/Chicago"
};

const day: { start: string, end: string } = { start: "00:00", end: "23:59" };

export const DateTimeWithMilliseconds = "MM/DD/YY h:mm:ss.SSS A";
export const DateTimeWithoutMilliseconds = "MM/DD/YY h:mm A";

export function convertToCentralTime(date: Date): Date {
    return new Date(Intl.DateTimeFormat("en", dateTimeFormatOptions).format(date));
}

export function isTimeBetween(nowTime: Moment, start: string = day.start, end: string = day.end): boolean {
    const time = nowTime.format("HH:mm");
    return (start ?? day.start) <= time && time <= (end ?? day.end);
}

export function isDateBetween(nowTime: Date, start: Date, end: Date): boolean {
    return moment(start).isBefore(nowTime) && moment(end).isAfter(nowTime);
}

export function formatShortDateTime(date: Date | string): string {
    if (date == null) return "";
    return moment(date).format(DateTimeWithoutMilliseconds);
}

export function formatFullDateTime(date: Date | string): string {
    if (date == null) return "";
    return moment(date).format(DateTimeWithMilliseconds);
}